import { FC, ReactNode, useState, useEffect } from 'react';
import { FooterContext } from './UseFooterContext';

export const FooterProvider: FC<{ children: ReactNode }> = ({ children }) => {
  const [isSidebarCollapsed, setSidebarCollapsed] = useState(false);

  // Check if the URL contains '/editor/' and automatically collapse the sidebar
  useEffect(() => {
    const pathname = window.location.pathname;
    const isEditorPage = pathname.includes('/editor/');
    if (isEditorPage) {
      setSidebarCollapsed(true);
    }
  }, []);

  // Add a listener to check when the URL changes
  useEffect(() => {
    const handleUrlChange = () => {
      const pathname = window.location.pathname;
      const isEditorPage = pathname.includes('/editor/');
      if (isEditorPage) {
        setSidebarCollapsed(true);
      }
    };

    // Listen for popstate events (back/forward navigation)
    window.addEventListener('popstate', handleUrlChange);

    return () => {
      window.removeEventListener('popstate', handleUrlChange);
    };
  }, []);

  return (
    <FooterContext.Provider value={{ isSidebarCollapsed, setSidebarCollapsed }}>
      {children}
    </FooterContext.Provider>
  );
};
